export default __webpack_public_path__ + "static/media/illus09.a9e3e266.png";